import { useState, type FormEvent } from 'react';
import { CODE_LENGTH, LIMITS } from '@elixir/shared';
import { navigate } from '../App';
import { api, ApiError, sessions } from '../state/api';

export function Landing() {
  const [quizName, setQuizName] = useState('');
  const [hostName, setHostName] = useState('');
  const [code, setCode] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function host(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const res = await api.createQuiz(quizName, hostName);
      sessions.save({ ...res, name: hostName.trim() });
      navigate(`/q/${res.code}`);
    } catch (err) {
      setError(err instanceof ApiError ? err.message : 'Could not create the quiz. Try again.');
      setBusy(false);
    }
  }

  function join(e: FormEvent) {
    e.preventDefault();
    const clean = code.replace(/[^A-Za-z0-9]/g, '').toUpperCase();
    if (clean.length === CODE_LENGTH) navigate(`/q/${clean}`);
    else setError(`Quiz codes are ${CODE_LENGTH} characters, like K7QX2P.`);
  }

  return (
    <main className="landing">
      <header className="landing-hero">
        <p className="wordmark">Elixir</p>
        <h1>One room. Every team. Whisper when it counts.</h1>
        <p className="lede">
          Everyone hears the quizmaster and the banter. Hold Space and only your team hears you, while the rest of the room
          fades down. No breakout rooms, no switching calls.
        </p>
      </header>

      <div className="landing-forms">
        <form className="panel" onSubmit={host}>
          <h2>Host a quiz</h2>
          <label>
            Quiz name
            <input value={quizName} onChange={(e) => setQuizName(e.target.value)} placeholder="Elixir, round one" maxLength={LIMITS.quizNameLength} />
          </label>
          <label>
            Your name
            <input value={hostName} onChange={(e) => setHostName(e.target.value)} placeholder="Quizmaster" maxLength={LIMITS.nameLength} required />
          </label>
          <button className="btn btn-primary" disabled={busy || !hostName.trim()}>
            {busy ? 'Creating…' : 'Create quiz room'}
          </button>
        </form>

        <form className="panel" onSubmit={join}>
          <h2>Join a quiz</h2>
          <label>
            Quiz code
            <input
              className="code-input"
              value={code}
              onChange={(e) => setCode(e.target.value.toUpperCase())}
              placeholder="K7QX2P"
              maxLength={CODE_LENGTH + 2}
              autoCapitalize="characters"
              spellCheck={false}
            />
          </label>
          <button className="btn" disabled={!code.trim()}>
            Find quiz
          </button>
          <p className="hint">Got an invite link? Just open it instead.</p>
        </form>
      </div>
      {error && (
        <p className="form-error" role="alert">
          {error}
        </p>
      )}
    </main>
  );
}
